import React, { useEffect, useState } from 'react';

const ProgressCircle = ({ percentage }) => {
  const radius = 80;
  const stroke = 40;
  const normalizedRadius = radius - stroke / 2;
  const circumference = 2 * Math.PI * normalizedRadius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  const [offset, setOffset] = useState(circumference); // start "vide"

  useEffect(() => {
    // trigger animation on mount
    setTimeout(() => {
      const progressOffset = circumference - (percentage / 100) * circumference;
      setOffset(progressOffset);
    }, 50); // tiny delay ensures it happens after render
  }, [circumference, percentage]);

  return (
    <svg
      height={radius * 2}
      width={radius * 2}
    >
      <circle
        stroke="#eee"
        fill="transparent"
        strokeWidth={stroke}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <circle
        stroke="#EB6424"
        fill="transparent"
        strokeWidth={stroke}
        strokeDasharray={circumference + ' ' + circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        r={normalizedRadius}
        cx={radius}
        cy={radius}
        className="progress-circle"
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dy=".3em"
        fontSize="24"
        fill="#EB6424"
      >
        {percentage}%
      </text>
    </svg>
    // <div class="progress-circle" data-progress="50">
    // <svg viewBox="0 0 36 36" class="circular-chart">
    //     <path class="circle-bg"
    //         d="M18 2.0845
    //             a 15.9155 15.9155 0 0 1 0 31.831
    //             a 15.9155 15.9155 0 0 1 0 -31.831"/>
    //     <path class="circle"
    //         stroke-dasharray="50, 100"
    //         d="M18 2.0845
    //             a 15.9155 15.9155 0 0 1 0 31.831
    //             a 15.9155 15.9155 0 0 1 0 -31.831"/>
    //     <text x="18" y="20.35" class="percentage">50%</text>
    // </svg>
    // </div>
  );
};

export default ProgressCircle;